<template>
  <div class="schoolAdmin">
    <v-row>
      <v-col>
        <v-row>
          <h1>This is an school admin page</h1>
        </v-row>
        <v-row>
          <h1>This is an school admin page</h1>
        </v-row>
        <v-row>
          <h1>This is an school admin page</h1>
        </v-row>
        <v-row>
          <h1>This is an school admin page</h1>
        </v-row>
        <v-row>
          <h1>This is an school admin page</h1>
        </v-row>
        <v-row>
          <h1>This is an school admin page</h1>
        </v-row>
        <v-row>
          <h1>This is an school admin page</h1>
        </v-row>
        <v-row>
          <h1>This is an school admin page</h1>
        </v-row>
        <v-row>
          <h1>This is an school admin page</h1>
        </v-row>
        <v-row>
          <h1>This is an school admin page</h1>
        </v-row>
        <v-row>
          <h1>This is an school admin page</h1>
        </v-row>
        <v-row>
          <h1>This is an school admin page</h1>
        </v-row>
        <v-row>
          <h1>This is an school admin page</h1>
        </v-row>
        <v-row>
          <h1>This is an school admin page</h1>
        </v-row>
        <v-row>
          <h1>This is an school admin page</h1>
        </v-row>
        <v-row>
          <h1>This is an school admin page</h1>
        </v-row>
        <v-row>
          <h1>This is an school admin page</h1>
        </v-row>
        <v-row>
          <h1>This is an school admin page</h1>
        </v-row>
        <v-row>
          <h1>This is an school admin page</h1>
        </v-row>
        <v-row>
          <h1>This is an school admin page</h1>
        </v-row>
        <v-row>
          <h1>This is an school admin page</h1>
        </v-row>
        <v-row>
          <h1>This is an school admin page</h1>
        </v-row>
        <v-row>
          <h1>This is an school admin page</h1>
        </v-row>
        <v-row>
          <h1>This is an school admin page</h1>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>

  export default {

    components: {
    },

    data(){
      return{
        person:{
          firstName: 'Sam',
          lastName: 'Riggs',
          email: 'SamIsRiggs@coolBeanz.coolio',
        }
      }
    }
  };
</script>
